import { FC } from "react";
import {
  HEADED_SECTION_HEADER_THEME_CLASS_MAP,
  THeadedSectionHeaderProps,
} from "./HeadedSection.config";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { cn } from "@/ui/lib";

export const HeadedSectionHeader: FC<THeadedSectionHeaderProps> = ({ title, theme }) => (
  <div
    data-component="HeadedSectionHeader"
    className={cn(
      "flex p-4 border-solid border-component-headed-section-base border-t border-l border-r",
      HEADED_SECTION_HEADER_THEME_CLASS_MAP[theme],
    )}
  >
    <TextSubtitle size={2} isResponsive={false}>{ title }</TextSubtitle>
  </div>
);
